<template>
  <div class="projects">
  	<div class="pageLabel strike hidden" :class="{hidden : $route.meta.rootActive}">
        <router-link to="/projects" exact>Projects</router-link>
     </div>
     <router-view />
  	<div class="project-list-container" id="recent">
  			<div class="section-description" :class="{hidden : !$route.meta.rootActive}">
	  			Recent work investigates systems, tools, and everything in-between. In practice, object-oriented approach focusses on inter-relationship (context and connections) between elements that comprise of the whole, their individual perspectives and boundaries in which they function. This conceptual inquiry manifests itself in form of activated objects and spaces.
	  		</div>
	  		<div class="section-content">
	  			<div class="project-list">
				<div class="project-list-item" v-for="(project, index)  in myJson.projectlistrecent" :key="index">
						<router-link :to="project.routelink" exact>
						<div class="project-thumbnail" :class="{hidden : !$route.meta.rootActive}">
							<img :src="project.thumbnail">
						</div>
	  					<div class="project-title">
	  					<span class="label-date project-date">{{project.datestamp}}
	  					</span>
	  						{{project.title}}
	  					</div>
	  					</router-link>
	  					<div class="project-tagline hidden">
	  						{{project.tagline}}
	  					</div>
				</div>
				</div>
			</div>
  	</div>
  	<div class="project-list-container" id="previously">
  			<div class="section-description" :class="{hidden : !$route.meta.rootActive}">
	  			Working as a UX Designer at Adobe Systems, I was responsible for defining user goals, setting design priorities, and deliver end-to-end workflows on projects and initiatives for professional creative tools and enterprise marketing solutions like Creative Cloud Services & Platform, Adobe InDesign and Adobe Social. Partnered with multiple stakeholders, including product managers, engineers, organizational leaders, and other designers to optimize existing experiences and develop new product concepts.
	  		</div>
	  		<div class="section-content">
	  			<div class="project-list">
				<div class="project-list-item" v-for="(project, index)  in myJson.projectlistprevious" :key="index">
						<router-link :to="project.routelink" exact>
						<div class="project-thumbnail" :class="{hidden : !$route.meta.rootActive}">
							<img :src="project.thumbnail">
						</div>
	  					<div class="project-title">
	  					<span class="label-date project-date">{{project.datestamp}}
	  					</span>
	  						{{project.title}}
	  					</div>
	  					</router-link>
	  					<div class="project-tagline hidden">
	  						{{project.tagline}}
	  					</div>
				</div>
				</div>
			</div>
  	</div>
  </div>
</template>
<script>
// @ is an alias to /src
import myData from '@/data.json';
import Navbar from '../components/Navbar.vue'

export default {
  name: "projects", 
  components: {
      Navbar
  }, 
  data() {
    return {
      myJson: myData
    }
  }
};
</script>
<style lang="stylus">
//Project Page CSS
.projects
	display grid
	grid-template-columns repeat(12, 1fr)
	grid-gap 1rem
	grid-auto-rows minmax(0px, auto)
	padding 1rem 0
	.project-block
		grid-column 1 / span 12
		.project-section-block
			display grid
			grid-template-columns repeat(12, 1fr)
			grid-gap 1rem
			grid-auto-rows minmax(0px, auto)
			.project-title-section
				grid-column 5 / span 4
				position relative
			.project-info-section
				grid-column 5 / span 4
			.project-graphic-section
				grid-column 3 / span 8
			.project-graphic-section-middle-small
				margin 4rem 0
				grid-column 3 / span 8
			.project-graphic-section-middle-big
				margin 4rem 0
				grid-column 1 / span 12
	.project-list-container
		padding-top 6rem
		grid-column 4 / span 6
		.section
			margin-bottom 10vh
.large
	.projects
		.pageLabel
			grid-column 4 / span 6
		.project-block
			.project-section-block
				.project-title-section
				.project-info-section
					grid-column 4 / span 6
				.project-graphic-section
					grid-column 2 / span 10
		.project-list-container
			padding-top 6rem
			grid-column 3 / span 8
.medium
	.projects
		padding 6rem 1rem 1rem 1rem
		.pageLabel
			grid-column 1 / span 8
			margin-bottom 1rem
			display none
		.project-block
			&:after
				text-align left
			.project-section-block
				.project-title-section
				.project-info-section
					grid-column 1 / span 8
				.project-graphic-section
					grid-column 1 / span 10
				.project-graphic-section-middle-small
					grid-column 1 / span 10
		.project-list-container
			padding-top 6rem
			grid-column 2 / span 10
.small
	.projects
		display block
		padding 8rem 1rem 1rem 1rem
		.project-block
			.project-section-block
				display block
				.project-title-section
					.project-meta
						max-width 100%
		.section-description
			padding 4rem 0
		.pageLabel
			display none
		.project-list-container
			padding-top 6rem
			grid-column 1 / span 12
			.project-list 
				.project-list-item 
					.project-title 
						.project-date
							text-align left
							display inline-block
							bottom -18px
							left 0

.spacedOut
	margin-top 10vh
.pageLabel
	grid-column 5 / span 4
	display inline-block
	margin-bottom 10vh
.scroll-button
	text-decoration none
	padding-bottom 2px
	&:hover
		text-decoration none
.section-description
	font-size .875rem
	padding 4rem 6rem
	position relative
	&:before
		content ""
		position absolute
		top 0
		left 0
		height 5px
		width 90px
		background-image url("../assets/bg-border.png")
		background-size 9px 5px
.section-content
	.project-list
		line-height 1
		.project-list-item
			margin-bottom 1rem
			.project-title
				position relative
				margin .5rem 0
				.project-date
					position absolute
					text-align right
					width 100px
					left -110px
					bottom 2px
					vertical-align bottom
					font-size .625rem
					color #000
			.project-tagline
				font-size .725rem
				opacity .75
.project-thumbnail
	padding-top 2rem
	img
		max-width 100%
		max-height 100%
		margin 0 auto

.project-block
	margin-bottom 20vh
	position relative
	&:after
		position absolute
		bottom -10vh
		content "↓ ↓ ↓"
		width 100%
		text-align center
	&.mini
		height 50vh
		overflow hidden
		position relative
	.project-info-section
		position relative
	.project-title
		margin-top 0rem
		margin-bottom 8px
		font-size 1rem
	.title-inner
		padding-bottom 2px
		border-bottom 1px solid #000
		display inline
		line-height 1.8
	.year-label
		vertical-align super
		font-size .625rem
		margin-left 8px
		font-weight 400
	.project-meta
		display block
		font-size .75rem
		opacity .85
		margin-bottom 2rem
		letter-spacing .45px
		max-width 40vw
	.diagram
		width 360px
		text-align center
		margin 2rem auto
		img
			max-width 100%
			max-height 100%
			margin 0 auto
	.graphic-img
		img
			max-width 100%
			max-height 100%
			margin 0 auto
	.caption
		font-size .875rem
		margin .5rem 0
		text-align center
</style>

<!-- 

  		<div class="section">
	  		<div class="section-description hidden" :class="{hidden : !$route.meta.rootActive}">
	  			The Object-oriented approach focuses on inter-relationship (context and connections) between elements that comprise of the whole, their individual perspectives and boundaries in which they function. This conceptual inquiry manifests itself in form of activated objects and spaces.
	  		</div>
	  		<div class="section-content">
	  			<ul class="project-list">
	  				<li class="project-list-item">
	  					<div class="project-title">
	  					<span class="label-date project-date">2019</span>
	  						<router-link to="/projects/artificiallyesoteric" exact>Artificially Esoteric
	  						</router-link>
	  					</div>
	  					<div class="project-tagline">
	  						Sample Tagline
	  					</div>
	  				</li>
	  				<li class="project-list-item">
	  					<div class="project-title">
	  					<span class="label-date project-date">2019</span>
	  						<router-link to="/projects/onetwenty" exact>One Twenty give-or-take Fifteen
	  						</router-link>
	  					</div>
	  					<div class="project-tagline">
	  						Sample Tagline
	  					</div>
	  				</li>
	  				<li class="project-list-item">
	  					<div class="project-title">
	  					<span class="label-date project-date">2018</span>
	  						<router-link to="/projects/wastemaker" exact>Wastemaker
	  						</router-link>
	  					</div>
	  					<div class="project-tagline">
	  						Sample Tagline
	  					</div>
	  				</li>
	  				<li class="project-list-item">
	  					<div class="project-title">
	  					<span class="label-date project-date">2018</span>
	  						<router-link to="/projects/symbioteI" exact>Symbiote I
	  						</router-link>
	  					</div>
	  					<div class="project-tagline">
	  						Sample Tagline
	  					</div>
	  				</li>
	  				<li class="project-list-item">
	  					<div class="project-title">
	  					<span class="label-date project-date">2018</span>
	  						<router-link to="/projects/symbioteII" exact>Symbiote II
	  						</router-link>
	  					</div>
	  					<div class="project-tagline">
	  						Sample Tagline
	  					</div>
	  				</li>
	  				<li class="project-list-item">
	  					<div class="project-title">
	  					<span class="label-date project-date">2018</span>
	  						<router-link to="/projects/destablize" exact>DeStabilize
	  						</router-link>
	  					</div>
	  					<div class="project-tagline">
	  						Sample Tagline
	  					</div>
	  				</li>
	  				<li class="project-list-item">
	  					<div class="project-title">
	  					<span class="label-date project-date">2018</span>
	  						<router-link to="/projects/ekkos" exact>Ekkos
	  						</router-link>
	  					</div>
	  					<div class="project-tagline">
	  						Sample Tagline
	  					</div>
	  				</li>
	  			</ul>
	  		</div>
	  	</div>
  		<div class="section">
	  		<div class="section-description hidden" :class="{hidden : !$route.meta.rootActive}">
				Responsible for defining user goals, setting design priorities, and deliver end-to-end workflows on projects and initiatives for professional creative tools and enterprise marketing solutions like Creative Cloud Services & Platform, Adobe InDesign and Adobe Social. Partnered with multiple stakeholders, including product managers, engineers, organizational leaders, and other designers to optimize existing experiences and develop new product concepts.
	  		</div>
	  		<div class="section-content">
	  			<ul class="project-list">
	  				<li class="project-list-item">
	  					<div class="project-title">
	  					<span class="label-date project-date">2016-17</span>
	  						<router-link to="/projects/creativecloud" exact>Creative Cloud Desktop
	  						</router-link>
	  					</div>
	  					<div class="project-tagline">
	  						Sample Tagline
	  					</div>
	  				</li>
	  				<li class="project-list-item">
	  					<div class="project-title">
	  					<span class="label-date project-date">2016</span>
	  						<router-link to="/projects/indesignnext" exact>InDesign Next
	  						</router-link>
	  					</div>
	  					<div class="project-tagline">
	  						Sample Tagline
	  					</div>
	  				</li>
	  				<li class="project-list-item">
	  					<div class="project-title">
	  					<span class="label-date project-date">2016</span>
	  						<router-link to="/projects/indesigntouch" exact>InDesign Touch
	  						</router-link>
	  					</div>
	  					<div class="project-tagline">
	  						Sample Tagline
	  					</div>
	  				</li>
	  				<li class="project-list-item">
	  					<div class="project-title">
	  					<span class="label-date project-date">2014-16</span>
	  						<router-link to="/projects/indesign" exact>Adobe InDesign
	  						</router-link>
	  					</div>
	  					<div class="project-tagline">
	  						Sample Tagline
	  					</div>
	  				</li>
	  				<li class="project-list-item">
	  					<div class="project-title">
	  					<span class="label-date project-date">2012-14</span>
	  						<router-link to="/projects/adobesocial" exact>Adobe Social
	  						</router-link>
	  					</div>
	  					<div class="project-tagline">
	  						Sample Tagline
	  					</div>
	  				</li>
	  			</ul>
	  		</div>
	  	</div> -->